export default class SyncConflictError extends Error {
  constructor(message, errorCode, statusCode, data) {
    super(message);
    this.name = 'SyncConflictError';
    this.statusCode = statusCode;
    this.errorCode = errorCode;
    this.data = data;
  }
}
